import React from 'react';
import clsx from 'clsx'
import Card from '@mui/material/Card';
import { Avatar, Typography, CardContent, Grid } from '@mui/material'
import PropTypes from 'prop-types'
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import { useSelector } from 'react-redux'
import { makeStyles } from '@mui/styles'
import { history } from '../../../../utils'
import { styled } from '@mui/material/styles';
import theme from './../../../../theme'

const useStyles = makeStyles((theme) => ({
  root: {
    alignItems: 'center',
    justifyContent: 'center',
    alignContent: 'center',
    marginLeft: 10,
    marginRight: 10,
    [theme.breakpoints.down('md')]: {
      width: '100%'
    },
    cursor: 'pointer'
  },
  title: {
    fontWeight: 500,
    color: theme.palette.primary.main
  }
}));

const CustomAvatar = styled(Avatar)({
  height: 45,
  width: 45,
  backgroundColor: '#FFC107',
  [theme.breakpoints.down('md')]: {
    height: 35,
    width: 35,
    display: 'flex'
  },
})

const CardOrdemServicoRecebendoOrcamentos = (props) => {
  const { className, ...rest } = props
  const classes = useStyles();

  const ordensServicoRecebendoOrcamento = useSelector((state) => (state.dashboard ? state.dashboard.dashboard.ordensServicoRecebendoOrcamento : undefined))

  return (
    <Card {...rest} className={clsx(classes.root, className)}>
      <CardContent>
        <Grid container justifyContent="space-between">
          <Grid item styles={{ display: 'flex', flexDirection: 'column' }}
            onClick={() => history.push('/ordensServicoAguardandoOrcamento')}>
            <Grid item>
              <Typography variant="h5" className={classes.title}>
                {ordensServicoRecebendoOrcamento ? ordensServicoRecebendoOrcamento : 0}
              </Typography>
            </Grid>
            <Grid item>
              <Typography variant="caption" gutterBottom>
                Ordens de serviço recebendo orçamentos
              </Typography>
            </Grid>
          </Grid>
          <Grid item>
            <CustomAvatar>
              <AttachMoneyIcon sx={{ fontSize: 25, color: '#25261C' }} />
            </CustomAvatar>
          </Grid>
        </Grid>
      </CardContent>
    </Card >
  );
}

CardOrdemServicoRecebendoOrcamentos.propTypes = {
  className: PropTypes.string,
  subtitle: PropTypes.string
}

export default CardOrdemServicoRecebendoOrcamentos
